import RIOSelect from '@rio-cloud/rio-uikit/Select';
import { Controller, type FieldValues, type Path } from 'react-hook-form';

import DarkSelect from './DarkSelect';
import type { FormFieldProps } from './types';

const FormFieldSelect = <T extends FieldValues, F extends Path<T>>({
    placeholder,
    name,
    options,
    error,
    label,
    control,
    dark,
    onChange,
}: FormFieldProps<T, F> & { dark?: boolean; onChange: () => void }) => {
    if (dark) {
        return <DarkSelect {...{ placeholder, name, options, error, label, control, onChange }} />;
    }
    return (
        <div className={`form-group mb-0 ${error && 'has-error has-feedback'}`}>
            <label htmlFor={name}>{label}</label>
            {control ? (
                <Controller
                    control={control}
                    name={name}
                    render={({ field }) => (
                        <RIOSelect
                            id={name}
                            placeholder={placeholder}
                            options={options}
                            onChange={item => {
                                field.onChange(item?.id);
                                onChange();
                            }}
                            btnClassName={`${dark && 'border-none bg-gray-darker text-white'}`}
                            dropdownClassName={`${dark && 'select'}`}
                        />
                    )}
                />
            ) : (
                <RIOSelect id={name} placeholder={placeholder} options={options} onChange={onChange} />
            )}
            {error && (
                <span className='help-block'>
                    <span>{error.message}</span>
                </span>
            )}
        </div>
    );
};
export default FormFieldSelect;
